const StripeSubscriptionService = () => {
    return {
        recurringLabels: {
            month: 'mois',
            year: 'an',
        }
    };
};

export default StripeSubscriptionService();
